<template>
    <div>
        <div class="leave-comment-part" v-if="commentData">
            <div class="leave-comment-title">
                <h3>LEAVE A COMMENT</h3>
                <div class="social-stats active">
                    <span><img src="/assets/img/bubble-icon.svg" alt="" width="18"> {{ comments.total }}</span>
                </div>
            </div>
            <tinymce id="editor" :other_options="tinymceOptions" :toolbar1="toolbar1" placeholder="Write your notes here..." v-model="commentData.message" :disabled="busy"></tinymce>

            <button class="btn btn-sm-alternative-primary mt-4" @click="addComment()" :disabled="!this.$route.params.doc_id"><img src="/assets/img/post-comment-icon.svg" alt="" width="21"> Post Comment</button>
        </div>

        <div v-infinite-scroll="loadComments" infinite-scroll-disabled="busy" infinite-scroll-distance="10"
             :class="{ 'user-comment-list' : comments.data && comments.data.length }">
            <div class="comment-list-box" v-for="(comment, index) in comments.data">
                <div class="user-img">
                    <avatar :src="'/storage/' + comment.user.photo"  :username="comment.user.name" class="user-img" v-if="comment.user.name" :size="44"></avatar>
                </div>
                <div class="user-comment-info">
                    <h6><a href="javascript:;">{{ comment.user.name }}</a> <span class="date">{{ comment.created_at | moment("D MMMM YYYY") }}</span>
                        <a v-if="userId == comment.user.id" @click.prevent="editComment(comment)" class="edit-comment-link">
                            <span v-if="editId == comment.id">(Cancel)</span>
                            <span v-else>(Edit)</span>
                        </a></h6>
                    <div class="leave-comment-part" v-if="editId == comment.id">
                        <editor
                            :id="'editor'+ comment.id"
                            v-model="editMessage"
                            :init="tinymceOptions"
                            style="width: auto; height: auto; overflow-y: hidden;"
                        ></editor>
                        <button class="btn btn-sm-alternative-primary" @click.prevent="updateComment(editMessage, comment);">
                            <img src="/assets/img/post-comment-icon.svg" alt="" width="21"> Post Comment</button>
                    </div>
                    <p v-else v-html="comment.message" class="tinymce-html"></p>
                </div>
            </div>

            <div class="see-more-comments" v-if="busy">
                <svg  class="rotate-infinite"
                      xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15"><g><g><path fill="#8e8e93" d="M2.936 5.288l1.65 1.687a.75.75 0 1 1-1.073 1.05l-.36-.367C3.231 10.913 5.834 13.5 9 13.5a5.763 5.763 0 0 0 4.355-1.995.75.75 0 1 1 1.129.99C13.141 14.025 11.184 15 9 15c-4.025 0-7.27-3.292-7.349-7.35l-.365.375a.75.75 0 0 1-1.072-1.05l1.65-1.687a.757.757 0 0 1 .536-.225c.202 0 .395.082.536.225zM9 1.5a5.763 5.763 0 0 0-4.355 1.995.75.75 0 1 1-1.129-.99C4.859.975 6.816 0 9 0c4.025 0 7.27 3.293 7.349 7.35l.365-.375a.75.75 0 0 1 1.072 1.05l-1.65 1.688a.757.757 0 0 1-.536.225.757.757 0 0 1-.536-.225l-1.65-1.688a.75.75 0 0 1 1.073-1.05l.36.368C14.769 4.088 12.166 1.5 9 1.5z"/></g></g></svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "../../api/api.service";
import Avatar from 'vue-avatar';
import tinymce from 'vue-tinymce-editor'
import Editor from "@tinymce/tinymce-vue";

export default {
    name: "TaskComments",
    components: {
        Avatar,
        tinymce,
        'editor': Editor
    },
    data() {
        return {
            commentData: {
                message: '',
                document_id: this.$route.params.doc_id,
                task_id: this.$route.params.id,
            },
            editId: null,
            userId: null,
            editMessage: null,

            comments: [],
            busy: false,
            currentPPage: 0,
            lastPPage: 1,

            tinymceOptions: {
                menubar: false,
                branding: false,
                statusbar: false,
                content_style: "body { font-family: 'Poppins', sans-serif; padding-left: 17px; color: #16181F;\n" +
                    "    font-size: 14px;\n" +
                    "    font-weight: 400;\n" +
                    "    line-height: normal; }",
                link_title: false,
                contextmenu: "link image",
                plugins: [
                    'autolink lists link image charmap print preview anchor',
                    'code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                ],
                toolbar: "formatselect | bold italic strikethrough | link | numlist bullist outdent indent"
            },
            toolbar1: "formatselect | bold italic strikethrough | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent"
        };
    },
    props: ['docId',],
    mounted() {
        // this.loadComments();
        // check share permissions
        this.userData = JSON.parse(localStorage.getItem('user'));
        this.userId = this.userData.id;
    },
    methods: {
        loadComments() {

            if(this.currentPPage == this.lastPPage) {
                return;
            } else {
                this.busy = true;
                setTimeout(() => {
                    let pageParams = {page: this.currentPPage + 1};
                    let id = {document_id: this.$route.params.doc_id};
                    let task_id = {task_id: this.$route.params.id};
                    let postParams = {...id, ...task_id, ...pageParams};
                    ApiService.setHeader();
                    ApiService.post('/api/planner-task/get-comments', postParams)
                        .then(({data}) => {
                            if(data.data.current_page === 1) {
                                this.comments = data.data;
                            } else {
                                for(let i=0; i<data.data.data.length; i++) {
                                    this.comments.data.push(data.data.data[i]);
                                }
                            }

                            this.currentPPage = data.current_page;
                            this.lastPPage = data.last_page;
                            this.busy = false;
                        })
                        .catch((res) => {
                            this.busy = true;
                        });


                    this.busy = false;
                }, 800);
            }
        },

        addComment() {
            this.commentData.message = this.commentData.message.replace(/(\r\n|\n|\r)/gm,"");
            ApiService.setHeader();
            ApiService.post('/api/planner-task/comments', this.commentData)
            .then(({data}) => {
                this.comments.data.unshift(data.data);
                this.comments.total++;
                this.commentData.message = '';
            })
            .catch((res) => {
                console.log(res);
            });
        },

        editComment(comment) {
            this.editMessage = comment.message;

            if(this.editId == comment.id) {
                this.editId = null;
            } else {
                this.editId = comment.id;
            }
        },

        updateComment(message, comment) {
            comment.message = message;
            ApiService.setHeader();
            ApiService.put('/api/planner-task/comments/' + comment.id, { message: message})
                .then(({ data }) => {
                    this.editId = null;
                })
                .catch((res) => {
                    console.log(res);
                });
        }

    }
}
</script>

<style scoped>
.leave-comment-part textarea {
    min-height:120px;
}
.leave-comment-part button {
    margin-right: 5px;
}
</style>
